"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactCountdownNow = _interopRequireDefault(require("react-countdown-now"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _Modal = require("@icare/components/lib/Modal");

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _paths = require("~/paths");

var _SCSessionService = _interopRequireDefault(require("./services/SCSessionService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ACTIVITY_STORAGE_KEY = 'lastActivty';
var CONTINUE_STORAGE_KEY = 'lastContinueSession';
var THROTTLE_AMOUNT = 1000;

var InactivityTimer = /*#__PURE__*/function (_React$Component) {
  _inherits(InactivityTimer, _React$Component);

  var _super = _createSuper(InactivityTimer);

  function InactivityTimer(props) {
    var _this;

    _classCallCheck(this, InactivityTimer);

    _this = _super.call(this, props);
    _this.state = {
      isModalOpen: false,
      willLogoutAt: null
    };
    _this.refreshTimeout = null;
    _this.inactivityTimer = null;
    _this.logoutTimer = null;
    _this._handleEndSessionClick = _this._handleEndSessionClick.bind(_assertThisInitialized(_this));
    _this._handleContinueSessionClick = _this._handleContinueSessionClick.bind(_assertThisInitialized(_this));
    _this.activityOccurred = (0, _throttle.default)(_this.activityOccurred.bind(_assertThisInitialized(_this)), THROTTLE_AMOUNT);
    return _this;
  }

  _createClass(InactivityTimer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          auth = _this$props.auth,
          inactivityTimeout = _this$props.inactivityTimeout;

      if (auth.isAuthenticated && inactivityTimeout) {
        this._setActivityListeners();

        this._sessionRefreshTimer(inactivityTimeout); // Treat this initial mount as activity :)


        this.activityOccurred();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._clearTimers();

      this._unsetActivityListeners();
    }
  }, {
    key: "_clearTimers",
    value: function _clearTimers() {
      if (this.refreshTimeout) {
        clearTimeout(this.refreshTimeout);
      }

      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }

      if (this.logoutTimer) {
        clearTimeout(this.logoutTimer);
      }
    } //region Getters

  }, {
    key: "_setActivityListeners",
    // endregion
    value: function _setActivityListeners() {
      window.addEventListener('keydown', this.activityOccurred);
      window.addEventListener('mousemove', this.activityOccurred);
      window.addEventListener('click', this.activityOccurred);
    }
  }, {
    key: "_unsetActivityListeners",
    value: function _unsetActivityListeners() {
      window.removeEventListener('keydown', this.activityOccurred);
      window.removeEventListener('mousemove', this.activityOccurred);
      window.removeEventListener('click', this.activityOccurred);
    }
  }, {
    key: "activityOccurred",
    value: function activityOccurred() {
      // Update localstorage so other tabs can sync
      var now = Date.now();

      if (localStorage) {
        localStorage.setItem(ACTIVITY_STORAGE_KEY, now);
      } // Reset the inactivity timer because activity has occured


      this._resetInactivityTimer(this.inactivityTimerLength);
    }
    /**
     * Start a loop that keeps our session alive
     * @private
     */

  }, {
    key: "_sessionRefreshTimer",
    value: function _sessionRefreshTimer(sessionLength) {
      var _this2 = this;

      var auth = this.props.auth;
      auth.extendSession().then(function () {
        var checkActivityAtMillis = sessionLength - _this2.props.inactivityWarning;
        _this2.refreshTimeout = setTimeout(function () {
          // TODO check for some condition on whether to continue the loop
          if (!_this2.state.isModalOpen) {
            _this2._sessionRefreshTimer(sessionLength);
          }
        }, checkActivityAtMillis);

        if (process.env.NODE_ENV === 'production') {
          var tokenId = auth.getIdToken();

          if (tokenId) {
            _SCSessionService.default.keepAliveSession(tokenId).catch(function (e) {
              console.error(e);
            });
          }
        }
      }).catch(function (error) {
        // TODO What happens when session doesn't refresh?
        console.error(error);
      });
    }
  }, {
    key: "_resetInactivityTimer",
    value: function _resetInactivityTimer(timerLength) {
      var _this3 = this;

      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }

      this.inactivityTimer = setTimeout(function () {
        var now = Date.now();
        var timerLength = _this3.inactivityTimerLength;
        var validUntil = _this3.lastActivity + timerLength;
        var difference = validUntil - now;

        if (difference > 0) {
          _this3._resetInactivityTimer(difference);
        } else {
          _this3._setLogoutTimer(_this3.props.inactivityWarning);
        }
      }, timerLength);
    }
  }, {
    key: "_setLogoutTimer",
    value: function _setLogoutTimer(timerLength) {
      var _this4 = this;

      this._clearTimers();

      this._unsetActivityListeners();

      var timerStart = Date.now();
      this.setState({
        isModalOpen: true,
        willLogoutAt: timerStart + timerLength
      });
      this.props.onSessionStart();
      this.logoutTimer = setTimeout(function () {
        if (timerStart > _this4.lastContinue) {
          _this4.props.onSessionTimeout();

          _this4.endSessionManually();
        } else {
          _this4.continueSession();
        }
      }, timerLength);
    } //region Continue Session

  }, {
    key: "_handleContinueSessionClick",
    value: function _handleContinueSessionClick() {
      this.props.onSessionContinue();
      this.continueSession();
    }
  }, {
    key: "continueSession",
    value: function continueSession() {
      var _this5 = this;

      this._clearTimers();

      if (localStorage) {
        localStorage.setItem(CONTINUE_STORAGE_KEY, Date.now());
      }

      this.setState({
        hasBeenActive: false,
        isModalOpen: false,
        willLogoutAt: null
      }, function () {
        // Reset the timer
        _this5._sessionRefreshTimer(_this5.props.inactivityTimeout);

        _this5._resetInactivityTimer(_this5.inactivityTimerLength);

        _this5._setActivityListeners();
      });
    } //endregion
    //region End Session

  }, {
    key: "_handleEndSessionClick",
    value: function _handleEndSessionClick() {
      this.props.onSessionEnd();
      this.endSessionManually();
    }
  }, {
    key: "endSessionManually",
    value: function endSessionManually() {
      this._clearTimers();

      this._unsetActivityListeners(); // Prevent unsaved changes alerts from stopping logout


      window.onbeforeunload = null; // Clear local auth session only

      this.props.auth.clearLocalSession(); // Redirect to login page

      location.href = _paths.authenticationPaths.login;
    } //endregion

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          auth = _this$props2.auth,
          inactivityTimeout = _this$props2.inactivityTimeout,
          children = _this$props2.children;
      var countdown = null;

      if (this.state.isModalOpen) {
        countdown = /*#__PURE__*/_react.default.createElement(_reactCountdownNow.default, {
          date: this.state.willLogoutAt,
          zeroPadTime: 1,
          renderer: function renderer(_ref) {
            var minutes = _ref.minutes,
                seconds = _ref.seconds;

            if (seconds.length < 2) {
              seconds = "0".concat(seconds);
            }

            return "".concat(minutes, ":").concat(seconds);
          }
        });
      }

      if (!auth.isAuthenticated && !inactivityTimeout) {
        return children;
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children, /*#__PURE__*/_react.default.createElement(_Modal.BasicModal, {
        isOpen: this.state.isModalOpen,
        title: "Warning",
        hideCloseBtn: true,
        buttons: [/*#__PURE__*/_react.default.createElement(_Button.default, {
          key: 1,
          onClick: this._handleEndSessionClick,
          variant: _Button.default.Variant.SECONDARY
        }, "End session now"), /*#__PURE__*/_react.default.createElement(_Button.default, {
          key: 2,
          onClick: this._handleContinueSessionClick,
          variant: _Button.default.Variant.PRIMARY
        }, "Continue session")]
      }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Due to inactivity, you will be logged out in ", countdown, " minutes.")), /*#__PURE__*/_react.default.createElement("p", null, "If you wish to remain logged in, please click continue your session.")));
    }
  }, {
    key: "lastActivity",
    get: function get() {
      if (localStorage) {
        return parseInt(localStorage.getItem(ACTIVITY_STORAGE_KEY));
      } else {
        return 0;
      }
    }
  }, {
    key: "lastContinue",
    get: function get() {
      if (localStorage) {
        return parseInt(localStorage.getItem(CONTINUE_STORAGE_KEY));
      } else {
        return 0;
      }
    }
  }, {
    key: "inactivityTimerLength",
    get: function get() {
      return this.props.inactivityTimeout - this.props.inactivityWarning;
    }
  }]);

  return InactivityTimer;
}(_react.default.Component);

_defineProperty(InactivityTimer, "propTypes", {
  auth: _propTypes.default.object.isRequired,

  /***
   * Timeout length in milliseconds
   */
  inactivityTimeout: _propTypes.default.number,
  inactivityWarning: _propTypes.default.number,
  onSessionContinue: _propTypes.default.func,
  onSessionEnd: _propTypes.default.func,
  onSessionStart: _propTypes.default.func,
  onSessionTimeout: _propTypes.default.func,
  children: _propTypes.default.node
});

_defineProperty(InactivityTimer, "defaultProps", {
  inactivityTimeout: null,
  inactivityWarning: 5 * 60 * 1000,
  onSessionContinue: function onSessionContinue() {},
  onSessionEnd: function onSessionEnd() {},
  onSessionStart: function onSessionStart() {},
  onSessionTimeout: function onSessionTimeout() {},
  children: null
});

var _default = InactivityTimer;
exports.default = _default;
//# sourceMappingURL=InactivityTimer.js.map